import { Flex, Text } from "@chakra-ui/react";

export default function CardExtract({description, value, bgColor, color}: any){
    return (
        <Flex
            w={"9.5vw"}
            h={"4vw"}
            bgColor={bgColor}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"space-evenly"}
            borderRadius={"8px"}
            color={color}
            textAlign="center"
        >
            <Text textTransform={"uppercase"} fontSize={"0.6vw"}>{description}</Text>
            <Text fontSize={"1vw"} fontWeight={"bold"}>{value ? value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            }) : `R$ 0,00`}</Text>
        </Flex>
    )
}